/**
 * 客服管理
 */
export default {
  csInfoselect: "/csInfo/select", // 查询
  csInfoupdate: "/csInfo/update", // 更新
  csInfodelete: "/csInfo/delete", // 删除{id}
}
